import { useEffect } from "react";
import type { Lang } from "../lib/types";
import Logo from "./Logo";

// ① 스플래시: 검은 배경 중앙 로고(언어 연동), 드로우온 후 자동 ②. 헤더·태그라인 없음.
export default function Splash({ lang, onDone }: { lang: Lang; onDone: () => void }) {
  useEffect(() => {
    const id = setTimeout(onDone, 1600);
    return () => clearTimeout(id);
  }, [onDone]);

  return (
    <div className="screen splash">
      <Logo lang={lang} height={64} stroke={20} draw className="logo-draw" />
    </div>
  );
}
